import { CustomerAccountConfigurations } from '@src/containers/Dealer/CustomerAccountConfigurations';
import type { CustomerAccountConfigurationsPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerAccountConfigurationsPanel({
  api,
  params,
}: LayoutPanelProps<CustomerAccountConfigurationsPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-account-configurations-panel"
    >
      <CustomerAccountConfigurations />
    </EntityAdminPanelShell>
  );
}
